<template>
    <div class="container p-0" style="margin-bottom: 30px;">
        <div class="insurance-history__menu__filters" >
            <button @click="filterStatusWrap()" style="width: 120px;text-align: left">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect y="4" width="24" height="2" fill="#24282C"/>
                    <rect y="18" width="24" height="2" fill="#24282C"/>
                    <circle cx="8" cy="5" r="4" fill="white" stroke="#24282C" stroke-width="2"/>
                    <circle cx="16" cy="19" r="4" fill="white" stroke="#24282C" stroke-width="2"/>
                </svg>
                {{ condition.isShowFilter ? 'Приховати' : 'Фільтри'}}
            </button>
        </div>
        <transition name="fade">
            <div v-show="condition.isShowFilter" class="menu filters mt-4">
            <div :class="{ row: !isMobile}">

                <div :class="['form-group', { row: isMobile, 'col-sm-4': !isMobile }]">
                    <div class="filter-title" style="">
                        Тип продукту
                    </div>
                    <el-select clearable  v-model="listQuery.quotationTypeId"
                               class="form-control-el"
                               multiple placeholder="Виберiть тип продукту">
                        <el-option v-for="item in quotationProducts"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </div>

                <div :class="['form-group', { row: isMobile, 'col-sm-4': !isMobile }]">
                    <div class="filter-title">
                        Дата створення
                    </div>
                    <DateInput
                      class="form-control-el w-100"
                      v-model="dateFilter"
                      type="input"
                      :range="true"
                      placeholder="Виберіть дату"
                      @change="refreshDate"
                    />
                </div>

                <div :class="['form-group', { row: isMobile, 'col-sm-4': !isMobile }]">
                  <div class="filter-title">ID запису</div>
                  <input class="form-control" v-model="listQuery.quotationId" placeholder="ID запису">
                </div>

                <div v-if="!isPartner()" :class="['form-group', { row: isMobile, 'col-sm-4': !isMobile }]">
                  <div class="filter-title">ID запису</div>
                  <input class="form-control" v-model="listQuery.userId" placeholder="ID точки">
                </div>

                <div :class="['form-group', { row: isMobile, 'col-sm-4': !isMobile }]" v-if="! isPartner() && !$store.getters.USER_INFO.organizationId">
                  <div class="filter-title">
                    Торгова точка
                  </div>
                  <el-select v-model="listQuery.partnerIds"
                             class="form-control-el"
                             multiple
                             placeholder="Виберіть торгову точку">
                    <el-option v-for="item in partnersList"
                               :key="item.id"
                               :label="item.fullName"
                               :value="item.id">
                    </el-option>
                  </el-select>
                </div>
            </div>

            <hr>

            <div :class="{ row: !isMobile}">
                <div :class="['form-group', { row: isMobile, 'col-sm-3': !isMobile }]">
                    <button @click="getList()" class="btn pl-0 w-100 btn-primary">
                        Застосувати
                    </button>
                </div>
            </div>

        </div>
        </transition>
    </div>
</template>

<script>

import { companyMixin, customerMixin, orderMixin, partnerMixin, userMixin } from '@/mixin';
import { DateInput } from '@/shared/ui/form';

export default {
  components: { DateInput },
  mixins: [userMixin, partnerMixin, companyMixin, orderMixin],
  name: 'FilterBlock',
  props: ['isLoadXml', 'isLoadData', 'orders', 'dates', 'quotationProducts', 'isMobile'],
  data: function () {
    return {
      dateFilter: new Date(),
      condition: {
        isShowBlock: false,
        isShowFilter: false,
        isShowChildrenUser:false
      },
      listQuery: {
        quotationId: null,
        userId: null,
        quotationTypeId: null,
        insurerName: null,
        partnerIds: null,
        toDate: moment().calendar(),
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < new Date().setHours(0, 0, 0, 0) || time.getTime() > new Date().setDate(new Date().getDate() + 30);
        },
      },
    };
  },
  created() {

    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
    oneWeekAgo.setHours(0, 0, 0, 0);
    this.defaultDates = [oneWeekAgo, moment()];
    this.dateFilter = [oneWeekAgo, moment()];

    this.refreshDate();
  },
  mounted: function () {

  },
  computed: {
    quotationTypesList() {
      return this.$store.getters.ALL_ORDER_TYPES.filter((item) => item.id !== 4);
    },
    partnersList() {
      return this.$store.getters.ALL_PARTNERS;
    },
  },
  methods: {
    getQuery() {
      this.listQuery.fromDate = moment(this.dateFilter[0]).format();
      this.listQuery.toDate =  moment(this.dateFilter[1]).format();

      return this.listQuery;
    },
    refreshDate: function() {
      this.listQuery.fromDate = moment(this.dateFilter[0]).format();
      this.listQuery.toDate =  moment(this.dateFilter[1]).format();
    },
    filterStatusWrap: function(scroll = false) {
      this.condition.isShowFilter = ! this.condition.isShowFilter;

      if (scroll) {
        let filter = this.$el.querySelector('.insurance-history__menu__filters');
        filter.scrollTop = filter.scrollHeight;
      }
    },
    getXls : function() {
      return this.$emit('download-xls');
    },
    getList() {
      this.condition.isShowFilter = false;
      return this.$emit('init-quotations-list');
    },
    initQuotationsList: function() {
      return this.$emit('init-quotations-list');
    }
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
    opacity: 0;
}

::v-deep .date-input--input {
  border: 1px solid #dde2e5 !important;
  border-radius: 3px !important;

  &:hover {
    border-color: #ffad3d !important;
  }
}

.btn-primary {
  padding: 10px 0px;
}
</style>
